import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-Googledrivefilterdata',
  templateUrl: './Googledrivefilterdata.component.html',
  styleUrls: ['./Googledrivefilterdata.component.css']
})

export class GoogledrivefilterdataComponent implements OnInit {
  @Input() data: any;
  googleDriveDataobjfilter = [
    {
      "name": "All",
      "value": "all",
      "icon": "icon-All-2"
    },

    {
      "name": "Image",
      "value": "image",
      "icon": "icon-Image"
    },
    {
      "name": "Spread Sheet",
      "value": "application/vnd.google-apps.spreadsheet",
      "icon": "icon-Spread-Sheet"

    }, {
      "name": "Document",
      "value": "application/vnd.google-apps.document",
      "icon": "icon-Google-Docs"

    }, {
      "name": "PDF",
      "value": "application/pdf",
      "icon": "icon-PDFs"
    },
    {
      "name": "Presentation",
      "value": "application/vnd.google-apps.presentation",
      "icon": "icon-Presentation-V"
    },
  ]
  sharingusre
  constructor() { }

  ngOnInit() {

    if (this.data.popupProps.curComp.isShowsharewithme == true) {
      this.sharingusre = this.data.popupProps.curComp.SharingUser


    }
  }
  Showfiltername(name) {
    this.data.popupProps.curComp.filtersharedata(name);
  }
  selectcategory(value) {
    this.data.popupProps.curComp.mimetype = value
    this.data.popupProps.curComp.filterdata(value);
    this.data.popupProps.showPopup = false
  }

}



// WEBPACK FOOTER //
// ./src/app/shelf/popups/Googledrivefilterdata/Googledrivefilterdata.component.ts